import { Image, Text, Box, VStack, HStack } from "@chakra-ui/react";
import { GradientDivider } from "./GradientDivider";
import { useState, useEffect } from "react";
import { StarDisplay } from "../../common/StarDisplay";
import { PeoplePile } from "../../user/PeoplePile";
import { TestimonialReviewType, TestimonialType } from "../types";

export function Testimonials({
  testimonials,
}: {
  testimonials: TestimonialType;
}) {
  return (
    <Box p={6} py={2} width="100%" borderRadius="24px">
      <VStack
        width="100%"
        gap={4}
        p={6}
        borderRadius="24px"
        border="1px solid"
        borderColor="transparent.white.10"
        background="transparent.black.20"
      >
        <PeoplePile
          readerAvatarsUrls={testimonials.readers_avatars_urls}
          readersCount={testimonials.readers_count_string}
        />
        <Text variant="paymentTestimonialTitle">{testimonials.title}</Text>
        <GradientDivider />
        <TestimonialCarousel reviews={testimonials.reviews} />
      </VStack>
    </Box>
  );
}

export function TestimonialCarousel({
  reviews,
  interval = 3000,
}: {
  reviews: TestimonialReviewType[];
  interval?: number;
}) {
  const [index, setIndex] = useState(0);

  // 1. Timer Logic
  useEffect(() => {
    if (reviews.length <= 1) return;
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % reviews.length);
    }, interval);
    return () => clearInterval(timer);
  }, [reviews.length, interval]);

  const review = reviews[index];

  return (
    <Box w="full" position="relative">
      <HStack
        key={index}
        w="full"
        gap={2}
        sx={{
          animation: "fadeIn 0.6s ease-in-out",
          "@keyframes fadeIn": {
            "0%": { opacity: 0 },
            "100%": { opacity: 1 },
          },
        }}
      >
        <VStack width="full">
          <HStack
            alignItems="center"
            justifyContent="space-between"
            width="full"
          >
            <HStack alignItems="center">
              <Image
                src={review.reviewer.avatar_url}
                boxSize={8}
                alt={review.reviewer.name}
                borderRadius="full"
              />
              <Text variant="paymentTestimonalReviewerName">
                {review.reviewer.name}
              </Text>
            </HStack>
            <StarDisplay rating={review.rating} />
          </HStack>
          <Text
            variant="paymentTestimonalReviewText"
            textAlign="left"
            width="full"
          >
            "{review.text}"
          </Text>
        </VStack>
      </HStack>
    </Box>
  );
}
